export enum PermissionsTypes {
  ALL = 'all',
  READ_BOARD_LEADS = 'read:leads_board',
  UPDATE_LEAD_STATUS = 'update:assign_agent_to_lead',
}
